import { Controller } from "@hotwired/stimulus"

// Toggles a password field between hidden and visible, swapping the eye icon.
export default class extends Controller {
  static targets = ["input", "icon"]

  connect() {
    this.useCssMask = this.inputTarget.classList.contains("security-masked")

    if (this.useCssMask) {
      const testInput = document.createElement("input")
      const isSupported = ("webkitTextSecurity" in testInput.style) || ("textSecurity" in testInput.style)
      if (!isSupported) {
        this.useCssMask = false
        this.inputTarget.type = "password"
        this.inputTarget.classList.remove("security-masked")
      }
    }
  }

  toggle() {
    if (this.useCssMask) {
      const isMasked = this.inputTarget.classList.contains("security-masked")
      this.inputTarget.classList.toggle("security-masked", !isMasked)
      this.iconTarget.classList.toggle("bi-eye-fill", !isMasked)
      this.iconTarget.classList.toggle("bi-eye-slash-fill", isMasked)
    } else {
      const isPassword = this.inputTarget.type === "password"
      this.inputTarget.type = isPassword ? "text" : "password"
      this.iconTarget.classList.toggle("bi-eye-fill", !isPassword)
      this.iconTarget.classList.toggle("bi-eye-slash-fill", isPassword)
    }
  }
}

